import { render } from "./SideNavItem.vue?vue&type=template&id=3268d55a"
import script from "./SideNavItem.vue?vue&type=script&lang=js"
export * from "./SideNavItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Navigation/SideNavItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3268d55a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3268d55a', __exports__)) {
    api.reload('3268d55a', __exports__)
  }
  
  module.hot.accept("./SideNavItem.vue?vue&type=template&id=3268d55a", () => {
    api.rerender('3268d55a', render)
  })

}


export default __exports__